import type { MenuPage } from '@/content/printMenu/types'
import { renderMenuPage } from '@/components/printMenu/renderMenuPage'

type MenuPrintStackProps = {
  pages: MenuPage[]
  totalPages: number
}

/** Linear page stack for print / save PDF — one A4 leaf per page in reading order. */
export function MenuPrintStack({ pages, totalPages }: MenuPrintStackProps) {
  return (
    <div className="print-menu-linear" aria-hidden="true">
      {pages.map((page, index) => (
        <div key={`print-${index + 1}`} className="print-menu-linear__page">
          {renderMenuPage(page, index + 1, totalPages)}
        </div>
      ))}
    </div>
  )
}
